import { Drawer, Form, message } from "antd";
import React from "react";
import { observer } from "mobx-react-lite";
import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { CommandBar, Persona, PersonaSize } from "@fluentui/react";
import moment from "moment";
const MonthlyPerformanceStoreCtx = React.createContext(MonthlyPerformanceStore);
export const QueryTemplatePreview = observer(() => {
  const monthlyPerformanceStore = React.useContext(MonthlyPerformanceStoreCtx);
  return (
    <Drawer
      title={monthlyPerformanceStore.selQuery?.title}
      visible={monthlyPerformanceStore.showQueryPreiviewDrawer}
      destroyOnClose={true}
      onClose={() => {
        monthlyPerformanceStore.showQueryPreiviewDrawer = false;
      }}
      width={"500px"}
      footer={
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm7">
              <Persona
                text={monthlyPerformanceStore.selQuery?.author}
                size={PersonaSize.size48}
              />
            </div>
            <div className="ms-Grid-col ms-sm5">
              <div>Created On:</div>
              <span style={{ color: "gray" }}>
                {moment(monthlyPerformanceStore.selQuery?.createdOn).format(
                  "LLLL"
                )}
              </span>
            </div>
          </div>
        </div>
      }
    >
      <Form layout="vertical">
      <CommandBar
          farItems={[{
            text:'Copy Script',
            key:'copy',
            onClick:()=>{
              navigator.clipboard.writeText(monthlyPerformanceStore.selQuery?.query);
              message.success('script copied successfully')
            }
          }]}
          ></CommandBar>
        <Form.Item label="Description:" style={{ fontWeight: "bold" }}>
          
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div
                className="ms-Grid-col ms-sm12"
                style={{ fontWeight: "normal" }}
              >
                {monthlyPerformanceStore.selQuery?.description}
              </div>
            </div>
          </div>
        </Form.Item>
        <Form.Item
          label="Template SQL Command Text:"
          style={{ fontWeight: "bold" }}
        >
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div
                className="ms-Grid-col ms-sm12"
                style={{
                  fontStyle: "italic",
                  height: "70vh",
                  backgroundColor: "gainsboro",
                  fontWeight: "normal",
                  display: "flex",
                }}
              >
                {monthlyPerformanceStore.selQuery?.query}
              </div>
            </div>
          </div>
        </Form.Item>
      </Form>
    </Drawer>
  );
});

